import styles from 'molecules/Main/main.module.scss';

import type { ComponentPropsWithoutRef, FC } from 'react';

type MainProps = ComponentPropsWithoutRef<'main'>;

const Main: FC<MainProps> = ({ children }) => <main className={styles.container}>{children}</main>;

export default Main;
